import {
  fetchQuizById,
  fetchQuizAttemptsByQuizId,
  postQuizAttemptByQuizId,
  putQuizAttemptByQuizId,
} from '@/models/quizzes'
import { uaaFetchStatus } from '@/models/auth'

const getQuizById = async (context, quizId) => {
  await uaaFetchStatus()
  try {
    const response = await fetchQuizById(quizId)
    context.commit('CURRENT_QUIZ_UPDATED', response)
  } catch (error) {
    const { detail } = error
    context.dispatch(
      'app/setError',
      `${detail || 'Something went wrong trying to find that quiz.'}`,
      { root: true }
    )
    context.commit('CURRENT_QUIZ_UPDATED', '')
  }
}

const getQuizAttemptsByQuizId = async (context, quizId) => {
  await uaaFetchStatus()
  try {
    const response = await fetchQuizAttemptsByQuizId(quizId)
    context.commit('PREVIOUS_QUIZ_ATTEMPTS_UPDATED', response)
  } catch (error) {
    const { detail } = error
    context.dispatch(
      'app/setError',
      `${detail ||
        'Something went wrong trying to find your previous attempts on this quiz.'}`,
      { root: true }
    )
  }
}

const startQuizAttemptByQuizId = async (context, quizId) => {
  await uaaFetchStatus()
  try {
    const response = await postQuizAttemptByQuizId(quizId)
    context.commit('STARTED_QUIZ_ATTEMPT', response)
  } catch (error) {
    const { detail } = error
    context.dispatch(
      'app/setError',
      `${detail || 'Something went wrong when trying to start this quiz.'}`,
      { root: true }
    )
  }
}

const finishQuizAttempt = async (context, data) => {
  await uaaFetchStatus()
  try {
    const response = await putQuizAttemptByQuizId(data)
    context.commit('FINISHED_QUIZ_ATTEMPT', response)
  } catch (error) {
    const { detail } = error
    context.dispatch(
      'app/setError',
      `${detail || 'Something went wrong when trying to finish the quiz.'}`,
      { root: true }
    )
  }
}

const clearQuizStore = context => {
  context.commit('CURRENT_QUIZ_UPDATED', '')
  context.commit('PREVIOUS_QUIZ_ATTEMPTS_UPDATED', '')
  context.commit('STARTED_QUIZ_ATTEMPT', '')
  context.commit('FINISHED_QUIZ_ATTEMPT', '')
}

const restartQuiz = context => {
  context.commit('FINISHED_QUIZ_ATTEMPT', '')
}

export default {
  getQuizById,
  getQuizAttemptsByQuizId,
  startQuizAttemptByQuizId,
  finishQuizAttempt,
  clearQuizStore,
  restartQuiz,
}
